import { render } from "./App.vue?vue&type=template&id=4bd1b98a"
const script = {}

import exportComponent from "/Users/louis/Dev/source/images/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__